import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const RegularError = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          padding: '1rem',
          fontSize: '1.25rem',
        }}
      >
        <Box sx={{ color: '#ee0000' }}>{t('messages.generalErrorMessage')}</Box>
      </Box>
    </>
  );
};

export default RegularError;
